module.exports = __webpack_public_path__ + "static/img/banner.35803ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/premier_league/banner.png
// module id = olzv
// module chunks = 1